import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { programData } from '../../data/programData';

const FundingSection = () => (
  <div className="space-y-6">
    <div className="text-center mb-6">
      <h2 className="text-3xl font-bold text-gray-900">Sustainable Funding Model</h2>
      <p className="text-gray-600 mt-2">Medicaid-focused strategy ensuring long-term program viability</p>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-xl font-semibold mb-2">ADHD Payor Distribution</h3>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={programData.payorMix}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }) => `${name}: ${percentage}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {programData.payorMix.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => value.toLocaleString()} />
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg">
        <h3 className="text-lg font-bold mb-2 text-blue-900">Funding Strategy</h3>
        <ul className="list-disc pl-6 text-blue-800 space-y-2">
          <li>Medicaid dominance (73.2%) creates sustainable foundation</li>
          <li>Commercial insurance provides additional revenue stream</li>
          <li>Self-pay options ensure universal access</li>
          <li>Focus on value-based care contracts</li>
        </ul>
      </div>
    </div>

    <div className="mt-8 p-4 border-l-4 border-green-200 bg-green-50">
      <strong>Funding Success:</strong> Strong Medicaid coverage provides stable foundation for program expansion and sustainability.
    </div>
  </div>
);

export default FundingSection;
